import React from 'react';
import { Card } from 'antd';

// ─── SVG Icons (mantidos do original, cliente solicitou) ─────────────────────
const IconSolar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 29 20" fill="none">
        <path d="M9.93647 16.7087V15.7026L7.43134 15.7162V16.7087C6.82412 17.0068 6.34116 17.5149 6.09544 18.1416C5.99659 18.3889 6.01354 18.6802 6.13499 18.9105C6.25643 19.1409 6.46825 19.2831 6.69702 19.2831H10.6708C10.8995 19.2831 11.1114 19.1443 11.2328 18.9105C11.3542 18.6802 11.3712 18.3889 11.2723 18.1416C11.0238 17.5183 10.5437 17.0068 9.93647 16.7087Z" fill="currentColor"/>
        <path d="M5.78678 15.1665L5.38574 14.6855C5.12591 14.3739 4.97622 13.9674 4.94233 13.5439L4.84912 13.7811C4.80676 13.8895 4.78982 14.0046 4.78982 14.1198H1.19451L1.87234 12.3854H5.14849L5.462 11.586H2.18583L2.82412 9.94988H6.10028L6.29798 9.44515L6.41378 9.15045H3.13761L3.7759 7.51432H7.05207L7.36556 6.71489H4.08939L4.73051 5.07876H8.00666L8.46702 3.90332H4.5328C4.27297 3.90332 4.03857 4.08285 3.92842 4.36401L2.97662 6.79957L2.00508 9.28256L1.0533 11.7181L0.101521 14.1537C-0.0170988 14.4585 0.0365628 14.821 0.234262 15.0581L0.547753 15.4341C0.672021 15.5832 0.841482 15.6679 1.01941 15.6679H1.02223L6.47308 15.6408C6.21325 15.5595 5.97884 15.3969 5.78678 15.1665Z" fill="currentColor"/>
        <path d="M28.7679 0.714747L28.3668 0.233733C28.2426 0.0846865 28.0731 0 27.8952 0H22.4302H22.3314H16.9681H16.8664H11.4014C11.1416 0 10.9072 0.179534 10.797 0.46069L9.57411 3.58729L8.32859 6.77485L7.10569 9.90145L5.88277 13.028C5.76415 13.3329 5.81781 13.6954 6.01551 13.9325L6.41657 14.4135C6.54083 14.5625 6.71029 14.6472 6.88822 14.6472H6.89104L15.3215 14.6066V16.3545C14.5279 16.7068 13.8981 17.3436 13.5874 18.1363C13.4885 18.3836 13.5055 18.6749 13.6269 18.9052C13.7484 19.1356 13.9602 19.2779 14.189 19.2779H19.2896C19.5184 19.2779 19.7302 19.139 19.8517 18.9052C19.9731 18.6749 19.99 18.3836 19.8912 18.1363C19.5805 17.3436 18.9507 16.7034 18.1571 16.3545V14.593L23.3001 14.5693C23.5543 14.5693 23.7887 14.3932 23.8988 14.1154L28.895 1.62597C29.0221 1.3211 28.9684 0.955255 28.7679 0.714747Z" fill="currentColor"/>
    </svg>
);

const IconConsumo = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 29 29" fill="none">
        <path d="M24.2424 3.79053C24.1643 3.95407 24.0602 4.11018 23.9338 4.25142L21.859 6.48528C22.7848 7.34017 23.5657 8.35488 24.1495 9.48482C24.6514 9.65951 25.0605 10.0572 25.2464 10.5776C25.4286 11.0905 25.3654 11.6443 25.0976 12.0978C25.2687 12.8598 25.3579 13.6515 25.3579 14.4655C25.3579 20.4534 20.4832 25.3262 14.4929 25.3262C12.9386 25.3262 11.4625 24.9992 10.1238 24.4082L7.08594 26.8762C9.25374 28.1734 11.7897 28.9242 14.4966 28.9242C22.4725 28.9242 28.961 22.4382 28.961 14.4655C28.9573 10.2393 27.1353 6.43324 24.2424 3.79053Z" fill="currentColor"/>
        <path d="M3.6347 14.4587C3.6347 9.11384 7.52039 4.65728 12.6145 3.7615L13.8379 1.99969C14.1725 1.5165 14.7266 1.22658 15.3178 1.22658H20.3264C18.5453 0.438594 16.5746 0 14.5035 0C6.5276 0 0.0390625 6.48599 0.0390625 14.4587C0.0390625 18.3875 1.61564 21.9557 4.17015 24.565L6.24872 21.5171C4.62008 19.6215 3.6347 17.1535 3.6347 14.4587Z" fill="currentColor"/>
        <path d="M15.0311 11.1996L22.6202 3.02612H15.3137L6.32268 15.9907L12.22 15.9647L5.44141 25.8962L23.5572 11.1773L15.0311 11.1996Z" fill="currentColor"/>
    </svg>
);

const IconBateria = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 26 35" fill="none">
        <path d="M4.23511 33.3833C9.07573 35.269 16.924 35.269 21.7646 33.3833C24.1844 32.4401 25.3954 31.2047 25.3954 29.9685V4.74609H0.605469V29.9693C0.605469 31.2039 1.81535 32.4401 4.23511 33.3833Z" fill="currentColor"/>
        <path d="M20.0687 31.7646C22.0071 31.009 22.9775 30.019 22.9775 29.0291V23.3823H3.11719V29.0291C3.11719 30.019 4.08641 31.009 6.02595 31.7646C9.90284 33.2758 16.1907 33.2758 20.0687 31.7646Z" fill="white"/>
        <path d="M20.0698 26.122C22.0082 25.3664 22.9786 24.3765 22.9786 23.3865C22.9786 22.3966 22.0093 21.4066 20.0698 20.651C16.1918 19.1398 9.90394 19.1398 6.02595 20.651C4.08751 21.4066 3.11719 22.3966 3.11719 23.3865C3.11719 24.3765 4.08641 25.3664 6.02595 26.122C9.90394 27.6333 16.1918 27.6333 20.0698 26.122Z" fill="currentColor"/>
        <path d="M20.0687 24.3046C22.0071 23.549 22.9775 22.5591 22.9775 21.5691V15.9224H3.11719V21.5691C3.11719 22.5591 4.08641 23.549 6.02595 24.3046C9.90284 25.8159 16.1907 25.8159 20.0687 24.3046Z" fill="white"/>
        <path d="M20.0698 18.6543C22.0082 17.8986 22.9786 16.9087 22.9786 15.9187C22.9786 14.9288 22.0093 13.9389 20.0698 13.1832C16.1918 11.672 9.90394 11.672 6.02595 13.1832C4.08751 13.9389 3.11719 14.9288 3.11719 15.9187C3.11719 16.9087 4.08641 17.8986 6.02595 18.6543C9.90394 20.1655 16.1918 20.1655 20.0698 18.6543Z" fill="currentColor"/>
        <path d="M20.0687 16.9965C22.0071 16.2409 22.9775 15.251 22.9775 14.261V8.61426H3.11719V14.261C3.11719 15.251 4.08641 16.2409 6.02595 16.9965C9.90284 18.507 16.1907 18.507 20.0687 16.9965Z" fill="white"/>
        <path d="M20.0698 11.3505C22.0082 10.5949 22.9786 9.60498 22.9786 8.61503C22.9786 7.62509 22.0093 6.63514 20.0698 5.87952C16.1918 4.36828 9.90394 4.36828 6.02595 5.87952C4.08751 6.63514 3.11719 7.62509 3.11719 8.61503C3.11719 9.60498 4.08641 10.5949 6.02595 11.3505C9.90394 12.861 16.1918 12.861 20.0698 11.3505Z" fill="currentColor"/>
        <path d="M21.7657 9.3728C24.1855 8.42957 25.3965 7.19418 25.3965 5.95805V4.92139H0.605469V5.95805C0.605469 7.19418 1.81535 8.42957 4.23621 9.3728C9.07683 11.2585 16.9251 11.2585 21.7657 9.3728Z" fill="white"/>
        <path d="M21.7657 8.33754C24.1855 7.39431 25.3965 6.15892 25.3965 4.92279C25.3965 3.68665 24.1866 2.45126 21.7657 1.50804C16.9251 -0.377678 9.07683 -0.377678 4.23621 1.50804C1.81645 2.45126 0.605469 3.68665 0.605469 4.92279C0.605469 6.15892 1.81535 7.39431 4.23621 8.33754C9.07683 10.2233 16.9251 10.2233 21.7657 8.33754Z" fill="currentColor"/>
        <path d="M9.21267 6.60247C11.35 7.43521 14.8148 7.43521 16.9511 6.60247C17.9697 6.20575 18.5016 5.69187 18.5489 5.17205H18.5533V2.79248H7.60938V5.17205H7.61377C7.66213 5.69187 8.194 6.20649 9.21267 6.60247Z" fill="#D3D3D3"/>
        <path d="M16.9511 4.2988C18.0192 3.8828 18.5533 3.33703 18.5533 2.79127C18.5533 2.2455 18.0192 1.69973 16.95 1.28373C14.8126 0.450995 11.3478 0.450995 9.21157 1.28373C8.14345 1.69973 7.60938 2.2455 7.60938 2.79127C7.60938 3.33703 8.14345 3.8828 9.21267 4.2988C11.35 5.13154 14.8148 5.13154 16.9511 4.2988Z" fill="white"/>
    </svg>
);

const IconCarregador = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 22 31" fill="none">
        <path d="M21.4032 6.411V5.68855L19.1081 2.74227L18.333 3.34432L20.4212 6.0272V6.41476C20.1917 6.5427 20.0223 6.74589 19.9396 6.99424H19.1984L18.4421 8.81167V7.3216C18.4421 7.05068 18.2201 6.83244 17.953 6.83244H16.7753V4.01786C16.7753 1.85049 15.0182 0.0932617 12.851 0.0932617H6.17256C4.00536 0.0932617 2.25204 1.84672 2.25204 4.01786V23.7989H2.20312V26.7979H16.7753V23.7989V22.7152V7.80701H17.4638V21.6729C17.4638 21.9438 17.6821 22.1659 17.953 22.1659H20.9103C21.1812 22.1659 21.3994 21.9476 21.3994 21.6729V10.7006C21.7155 10.5275 21.9337 10.1964 21.9337 9.80881V7.30279C21.9375 6.91899 21.7192 6.58785 21.4032 6.411ZM14.2544 10.1512H4.77667V3.0433H14.2544V10.1512Z" fill="currentColor"/>
        <path d="M18.5364 28.0703H0.0625V30.4597H18.5364V28.0703Z" fill="currentColor"/>
        <path d="M9.39899 13.6202L7.625 20.243L9.24279 19.3057L8.00275 24.3409L12.0128 15.9236L9.63872 17.2983L11.5333 12.3833L9.39899 13.6202Z" fill="#C3E1FF"/>
    </svg>
);

const IconGrid = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 19 31" fill="none">
        <path d="M18.1335 4.48216C18.1041 4.40999 18.0601 4.34142 18.0014 4.28368L13.8181 0.169614C13.7043 0.0577403 13.5539 0 13.3998 0H13.3667H5.63132H5.59831C5.44052 0 5.29006 0.0613491 5.17998 0.169614L0.996677 4.28368C0.937964 4.33781 0.893935 4.40638 0.864578 4.48216H0.824219V4.67704V6.97947V7.21766H2.00948V6.97947V5.27972H5.03686V6.04118L0.996677 10.0145L0.824219 10.3104V12.8077H2.00948V12.5695V11.0069H5.03686V12.0246L2.1526 29.0547L1.99848 29.9388L3.16907 30.1337L3.24979 29.6682L9.44767 24.4642L15.763 29.762L15.8254 30.1337L16.9959 29.9388L13.9649 12.0246V11.0069H16.9923V12.8077H18.1775V10.3104L13.9649 6.03757V5.27611H16.9923V7.21405H18.1775V4.47856H18.1335V4.48216ZM5.03686 9.84488H2.84615L5.03686 7.69041V9.84488ZM5.03686 4.11406H2.84615L5.03686 1.95959V4.11406ZM9.44767 22.9341L5.1176 19.2964L9.49905 15.7742L13.8328 19.2567L9.44767 22.9341ZM13.9612 9.84488H11.7705L13.9612 7.69041V9.84488ZM13.9612 4.11406H11.7705L13.9612 1.95959V4.11406Z" fill="currentColor"/>
    </svg>
);

// ─── Helpers ─────────────────────────────────────────────────────────────────
function fmtKw(val) {
    const v = Math.abs(parseFloat(val) || 0);
    if (v === 0) return '0 kW';
    if (v < 1) return `${(v * 1000).toFixed(0)} W`;
    return `${v.toFixed(2)} kW`;
}
function toKw(val) {
    const v = parseFloat(val) || 0;
    return v > 100 ? v / 1000 : v;
}

// ─── Caixa de nó ─────────────────────────────────────────────────────────────
function FlowNode({ icon, label, value, sublabel, color, active, style = {} }) {
    return (
        <div style={{
            position: 'absolute',
            width: 148,
            padding: '10px 12px',
            borderRadius: 10,
            border: `2px solid ${active ? color : '#e0e0e0'}`,
            background: active ? `${color}18` : '#fafafa',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            boxShadow: active ? `0 2px 12px ${color}44` : '0 1px 4px #0001',
            transition: 'all 0.3s',
            ...style,
        }}>
            <div style={{ color: active ? color : '#ccc', flexShrink: 0, lineHeight: 0 }}>
                {icon}
            </div>
            <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 10, color: '#999', whiteSpace: 'nowrap' }}>{label}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: active ? color : '#ccc', lineHeight: 1.2 }}>
                    {fmtKw(value)}
                </div>
                {sublabel && (
                    <div style={{ fontSize: 10, color: active ? color : '#ccc', marginTop: 2 }}>
                        {sublabel}
                    </div>
                )}
            </div>
        </div>
    );
}

// ─── Diagrama principal ───────────────────────────────────────────────────────
// Layout (container 760 × 340):
//   Solar    (left:20,  top:130)  centro (114, 165)
//   Consumo  (left:300, top:20)   centro (374,  55)
//   Grid     (left:580, top:130)  centro (654, 165)
//   Bateria  (left:160, top:250)  centro (234, 285)
//   Carregador(left:440,top:250)  centro (514, 285)
//
// Dimensão da caixa: 148 × 68 px

const NW = 148, NH = 68; // node width, node height
// posições absolutas (left, top) de cada nó
const NP = {
    solar:      { l: 20,  t: 130 },
    consumo:    { l: 306, t: 20  },
    grid:       { l: 592, t: 130 },
    bateria:    { l: 160, t: 252 },
    carregador: { l: 444, t: 252 },
};

// Centro de cada nó
function cx(key) { return NP[key].l + NW / 2; }
function cy(key) { return NP[key].t + NH / 2; }

// Ponto na borda de um nó em uma direção (right, left, top, bottom)
function ep(key, side) {
    switch (side) {
        case 'right':  return { x: NP[key].l + NW, y: cy(key) };
        case 'left':   return { x: NP[key].l,       y: cy(key) };
        case 'top':    return { x: cx(key),          y: NP[key].t };
        case 'bottom': return { x: cx(key),          y: NP[key].t + NH };
        default:       return { x: cx(key),          y: cy(key) };
    }
}

// Seta como path SVG com animação de dash + polígono para a ponta (sem defs/marker)
function FlowArrow({ x1, y1, x2, y2, bend = 0, color, active }) {
    const len = Math.hypot(x2 - x1, y2 - y1) || 1;
    // Ponto de controle da curva quadrática (perpendicular ao segmento)
    const mx = (x1 + x2) / 2 - bend * (y2 - y1) / len;
    const my = (y1 + y2) / 2 + bend * (x2 - x1) / len;

    const d = bend !== 0
        ? `M ${x1} ${y1} Q ${mx} ${my} ${x2} ${y2}`
        : `M ${x1} ${y1} L ${x2} ${y2}`;

    // Direção da tangente no ponto final (de mx,my → x2,y2 para curva; x1→x2 para linha)
    const tanX = bend !== 0 ? x2 - mx : x2 - x1;
    const tanY = bend !== 0 ? y2 - my : y2 - y1;
    const tanLen = Math.hypot(tanX, tanY) || 1;
    const angle = Math.atan2(tanY / tanLen, tanX / tanLen);
    const AL = 9; // comprimento da ponta
    const AW = 0.45; // abertura em radianos
    const ax1 = x2 - AL * Math.cos(angle - AW);
    const ay1 = y2 - AL * Math.sin(angle - AW);
    const ax2 = x2 - AL * Math.cos(angle + AW);
    const ay2 = y2 - AL * Math.sin(angle + AW);

    const strokeColor = active ? color : '#ddd';
    const fillColor   = active ? color : '#ddd';

    return (
        <>
            <path
                d={d}
                fill="none"
                stroke={strokeColor}
                strokeWidth={active ? 2.5 : 1.5}
                strokeDasharray={active ? '10 5' : '5 5'}
                style={active ? { animation: 'flowDash 1.2s linear infinite' } : {}}
            />
            {/* ponta da seta como polígono */}
            <polygon
                points={`${x2},${y2} ${ax1},${ay1} ${ax2},${ay2}`}
                fill={fillColor}
            />
        </>
    );
}

const EnergyFlowDiagram = ({ data = {} }) => {
    const solar    = parseFloat(data.solar)       || 0;
    const consumo  = parseFloat(data.consumption) || 0;
    const battery  = parseFloat(data.battery)     || 0;
    const grid     = parseFloat(data.grid)        || 0;
    const charger  = toKw(data.charger)           || 0;
    const soc      = data.batterySoc;

    const solarOn   = solar > 0.05;
    const consumoOn = consumo > 0.05;
    // grid > 0 = exportando; grid < 0 = importando
    const exporting = grid > 0.05;
    const importing = grid < -0.05;
    // battery > 0 = carregando (recebendo); < 0 = descarregando (fornecendo)
    const batCharg  = battery > 0.05;
    const batDisch  = battery < -0.05;
    const chargerOn = charger > 0.05;
    const socPct    = soc != null ? `SOC: ${parseFloat(soc).toFixed(0)}%` : null;
    const gridLabel = importing ? '← Importando' : exporting ? '→ Exportando' : null;

    // setas: cada entrada define [x1,y1, x2,y2, bend, color, active]
    const arrows = [
        // Solar → Consumo
        { x1: ep('solar','right').x, y1: ep('solar','right').y - 10,
          x2: ep('consumo','left').x, y2: ep('consumo','left').y + 10,
          bend: -30, color: '#FB8500', active: solarOn },

        // Solar → Grid (exportando)
        { x1: ep('solar','right').x, y1: ep('solar','right').y + 10,
          x2: ep('grid','left').x, y2: ep('grid','left').y + 10,
          bend: 30, color: '#FB8500', active: solarOn && exporting },

        // Grid → Consumo (importando)
        { x1: ep('grid','left').x, y1: ep('grid','left').y - 10,
          x2: ep('consumo','right').x, y2: ep('consumo','right').y + 10,
          bend: -30, color: '#1890ff', active: importing },

        // Solar → Bateria (carregando com solar)
        { x1: ep('solar','bottom').x + 10, y1: ep('solar','bottom').y,
          x2: ep('bateria','left').x, y2: ep('bateria','left').y - 5,
          bend: 10, color: '#FB8500', active: solarOn && batCharg },

        // Grid → Bateria (carregando da rede)
        { x1: ep('grid','bottom').x, y1: ep('grid','bottom').y,
          x2: ep('bateria','right').x, y2: ep('bateria','right').y - 5,
          bend: -10, color: '#1890ff', active: importing && batCharg },

        // Bateria → Consumo (descarregando)
        { x1: ep('bateria','right').x, y1: ep('bateria','right').y - 10,
          x2: ep('consumo','bottom').x - 20, y2: ep('consumo','bottom').y,
          bend: -20, color: '#722ed1', active: batDisch },

        // Solar → Carregador
        { x1: ep('solar','bottom').x + 20, y1: ep('solar','bottom').y,
          x2: ep('carregador','left').x, y2: ep('carregador','left').y - 5,
          bend: 20, color: '#FB8500', active: solarOn && chargerOn },

        // Bateria → Carregador
        { x1: ep('bateria','right').x, y1: ep('bateria','right').y + 10,
          x2: ep('carregador','left').x, y2: ep('carregador','left').y + 10,
          bend: 0, color: '#722ed1', active: batDisch && chargerOn },
    ];

    return (
        <Card title="Fluxo de Energia" bodyStyle={{ padding: 16 }}>
            <style>{`
                @keyframes flowDash {
                    from { stroke-dashoffset: 30; }
                    to   { stroke-dashoffset: 0; }
                }
            `}</style>
            <div style={{ width: '100%', overflowX: 'auto' }}>
                <div style={{
                    position: 'relative',
                    width: 760,
                    height: 340,
                    margin: '0 auto',
                }}>
                    {/* SVG overlay para as setas */}
                    <svg
                        width={760} height={340}
                        style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
                    >
                        {arrows.map((a, i) => (
                            <FlowArrow key={i} {...a} />
                        ))}
                    </svg>

                    {/* Nós */}
                    <FlowNode
                        icon={<IconSolar />}
                        label="Solar PV"
                        value={solar}
                        color="#FB8500"
                        active={solarOn}
                        style={{ left: NP.solar.l, top: NP.solar.t }}
                    />
                    <FlowNode
                        icon={<IconConsumo />}
                        label="Consumo"
                        value={consumo}
                        color="#52c41a"
                        active={consumoOn}
                        style={{ left: NP.consumo.l, top: NP.consumo.t }}
                    />
                    <FlowNode
                        icon={<IconGrid />}
                        label="Rede Elétrica"
                        value={Math.abs(grid)}
                        sublabel={gridLabel}
                        color="#1890ff"
                        active={importing || exporting}
                        style={{ left: NP.grid.l, top: NP.grid.t }}
                    />
                    <FlowNode
                        icon={<IconBateria />}
                        label="Bateria"
                        value={Math.abs(battery)}
                        sublabel={socPct}
                        color="#722ed1"
                        active={batCharg || batDisch}
                        style={{ left: NP.bateria.l, top: NP.bateria.t }}
                    />
                    <FlowNode
                        icon={<IconCarregador />}
                        label="Carregador EV"
                        value={charger}
                        color="#13c2c2"
                        active={chargerOn}
                        style={{ left: NP.carregador.l, top: NP.carregador.t }}
                    />
                </div>
            </div>
        </Card>
    );
};

export default EnergyFlowDiagram;
